module.exports = __webpack_public_path__ + "static/img/MRI_5.ba18f524.jpg";